const BYTE_BASE = 1024;
const DECIMAL_PLACES = 1;
const KILO_BYTE = 1024;
const MEGA_BYTE = KILO_BYTE * BYTE_BASE;
const GIGA_BYTE = MEGA_BYTE * BYTE_BASE;

// eslint-disable-next-line require-jsdoc
export function getFilesizeLabel(filesize) {
    const bytes = filesize;
    if ((bytes >= KILO_BYTE) && (bytes < MEGA_BYTE)) {
        return `${(bytes / KILO_BYTE).toFixed(DECIMAL_PLACES)} KB`;
    } else if ((bytes >= MEGA_BYTE) && (bytes < GIGA_BYTE)) {
        return `${(bytes / MEGA_BYTE).toFixed(DECIMAL_PLACES)} MB`;
    }

    return `${bytes} B`;
}
